<template>
  <div>
    <div uk-sticky="" class="nav-wrapper">
      <!--  TOP NAV -->
      <section class="uk-section uk-padding-remove-vertical uk-margin-small-bottom topnav">
        <div class="uk-container uk-container-xsmall headwrap  uk-padding-remove-horizontal">
          <div class="uk-navbar-container tm-navbar-container uk-sticky" style="">
            <div class="uk-container">
              <div uk-grid class="uk-flex uk-flex-middle flex-inline">
                <div class="uk-width-1-5 uk-text-center">
                  <a href="javascript:history.go(-1)" uk-icon="icon: chevron-left; ratio: 1.6"></a>
                </div>
                <div class="uk-width-3-5 uk-text-center">
                  <router-link to="/">
                    <img :src="getImage('app-header-logo.png')" alt="Logo" width="250" height="34">
                  </router-link>
                </div>
                <div class="uk-width-1-5 uk-text-center flex-inline" style="width: 20%!important; padding-left: 0px !important;">
                  <span class="uk-icon" uk-icon="icon: search; ratio: 1.3"
                        uk-toggle="target: #modal-search"></span>
                  <span class="uk-icon" uk-icon="icon: more-vertical; ratio: 1.3"
                        uk-toggle="target: #offcanvas-nav"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--  // TOP NAV -->
    </div>
    <!--<div class="uk-sticky-placeholder" style="height: 85px; margin: 0px;"></div>-->
    <div id="modal-search" uk-modal>
      <div class="uk-modal-dialog" style="border-radius: 8px;">

        <button class="uk-modal-close-default" type="button" uk-close></button>

        <div class="uk-modal-header" style="border-radius: 8px 8px 0 0;">
          <h2 class="uk-modal-title">
            <div class="uk-inline">
              <span class="uk-form-icon" uk-icon="icon: search"></span>
              <input class="uk-input uk-form-width-large search-field" type="text" placeholder="Search" style="border-bottom: #a7a7a7 solid 1px" v-model="searchTerm" @input="startSearch">
              <span v-if="searchTerm" class="reset-search" uk-icon="icon: close" @click="clearSearch"></span>
            </div>
          </h2>
          <ul uk-tab="connect: #search-contents">
            <li class="uk-active"><a href="#">Stores</a></li>
            <li><a href="#">Coupons</a></li>
            <li><a href="#">Loyalty</a></li>
          </ul>
        </div>

        <div class="uk-modal-body" uk-overflow-auto>

          <div id="search-placeholder" v-if="shouldShowWaitingToSearch">
            <div class="uk-text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="147.049" height="121.639" viewBox="0 0 147.049 121.639">
                <g id="Group_107" data-name="Group 107" transform="translate(0 0)">
                  <path id="Path_574" data-name="Path 574" d="M163.164,207.113c15.139,16.742-28.745,40.869-64.2,40.869s-59.992-18.694-64.2-40.869c-10.215-53.765,87.038-87.938,64.2-40.869C65.677,234.854,151.242,193.928,163.164,207.113Z" transform="translate(-34 -126.342)" fill="#3f3d56"/>
                  <circle id="Ellipse_129" data-name="Ellipse 129" cx="1.29" cy="1.29" r="1.29" transform="translate(45.687 26.087)" fill="#d0cde1"/>
                  <circle id="Ellipse_130" data-name="Ellipse 130" cx="1.29" cy="1.29" r="1.29" transform="translate(28.205 103.323)" fill="#d0cde1"/>
                  <circle id="Ellipse_131" data-name="Ellipse 131" cx="0.573" cy="0.573" r="0.573" transform="translate(48.696 45.719)" fill="#d0cde1"/>
                  <circle id="Ellipse_132" data-name="Ellipse 132" cx="0.573" cy="0.573" r="0.573" transform="translate(18.604 75.524)" fill="#d0cde1"/>
                  <circle id="Ellipse_133" data-name="Ellipse 133" cx="0.573" cy="0.573" r="0.573" transform="translate(93.977 97.018)" fill="#d0cde1"/>
                  <circle id="Ellipse_134" data-name="Ellipse 134" cx="0.573" cy="0.573" r="0.573" transform="translate(16.741 46.292)" fill="#d0cde1"/>
                  <path id="Path_575" data-name="Path 575" d="M364.078,222.107h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-311.944 -190.431)" fill="#d0cde1"/>
                  <path id="Path_576" data-name="Path 576" d="M209.145,255.524h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-178.935 -219.119)" fill="#d0cde1"/>
                  <path id="Path_577" data-name="Path 577" d="M107.882,445.9H107.6v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-92.001 -382.555)" fill="#d0cde1"/>
                  <circle id="Ellipse_135" data-name="Ellipse 135" cx="0.573" cy="0.573" r="0.573" transform="translate(55.574 109.342)" fill="#d0cde1"/>
                  <circle id="Ellipse_136" data-name="Ellipse 136" cx="0.573" cy="0.573" r="0.573" transform="translate(53.711 80.11)" fill="#d0cde1"/>
                  <circle id="Ellipse_137" data-name="Ellipse 137" cx="0.573" cy="0.573" r="0.573" transform="translate(121.49 90.714)" fill="#d0cde1"/>
                  <path id="Path_578" data-name="Path 578" d="M369.141,684.881h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-316.29 -587.719)" fill="#d0cde1"/>
                  <path id="Path_579" data-name="Path 579" d="M565.592,756.778h-.286v-.286h-.143v.286h-.287v.143h.287v.287h.143v-.287h.286Z" transform="translate(-484.942 -649.442)" fill="#d0cde1"/>
                  <path id="Path_580" data-name="Path 580" d="M69.4,576.529h-.287v-.287h-.143v.287h-.287v.143h.287v.286h.143v-.286H69.4Z" transform="translate(-58.966 -494.699)" fill="#d0cde1"/>
                  <path id="Path_581" data-name="Path 581" d="M350.914,430.71h-.287v-.287h-.143v.287H350.2v.143h.287v.287h.143v-.287h.287Z" transform="translate(-300.642 -369.515)" fill="#d0cde1"/>
                  <path id="Path_582" data-name="Path 582" d="M226.36,311.219h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-193.714 -266.933)" fill="#d0cde1"/>
                  <path id="Path_583" data-name="Path 583" d="M309.4,510.708h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-264.999 -438.193)" fill="#d0cde1"/>
                  <path id="Path_584" data-name="Path 584" d="M187.88,636.274h-.287v-.287h-.143v.287h-.287v.143h.287v.287h.143v-.287h.287Z" transform="translate(-160.679 -545.99)" fill="#d0cde1"/>
                  <ellipse id="Ellipse_138" data-name="Ellipse 138" cx="8.454" cy="1.29" rx="8.454" ry="1.29" transform="translate(24.622 63.487)" fill="var(--gp-orange)"/>
                  <path id="Path_585" data-name="Path 585" d="M221.661,462.8c-3.456,0-8.6-.382-8.6-1.433s5.142-1.433,8.6-1.433,8.6.382,8.6,1.433S225.117,462.8,221.661,462.8Zm0-2.579a41.61,41.61,0,0,0-5.957.376c-1.863.284-2.355.628-2.355.77s.492.486,2.355.77a47.349,47.349,0,0,0,11.913,0c1.862-.284,2.355-.628,2.355-.77s-.492-.486-2.355-.77A41.611,41.611,0,0,0,221.661,460.225Z" transform="translate(-187.724 -397.597)" fill="#d0cde1"/>
                  <path id="Path_587" data-name="Path 587" d="M329.527,170.867C317.6,157.683,232.04,198.608,265.322,130c14.836-30.583-21.024-26.868-45.163-5.767,23.375-16.051,51.591-16.513,38.141,11.212-33.282,68.61,52.283,27.684,64.2,40.869,5.547,6.135,3.169,13.261-3.816,19.829C330.695,188.272,336.656,178.751,329.527,170.867Z" transform="translate(-193.816 -95.226)" fill="#e6e6e6"/>
                  <path id="Path_588" data-name="Path 588" d="M452.721,797.743l-.184-.069a10.753,10.753,0,0,1-6.916-12.825l.044-.192.184.069a10.753,10.753,0,0,1,6.915,12.825Zm-5.843-5.295a12.047,12.047,0,0,0,5.59,4.826,10.37,10.37,0,0,0-6.551-12.149A12.062,12.062,0,0,0,446.878,792.448Z" transform="translate(-387.172 -676.366)" fill="#d0cde1"/>
                  <path id="Path_589" data-name="Path 589" d="M417.942,824.727a12.29,12.29,0,0,1,4.7,6.1,10.582,10.582,0,0,1-12.292-7.4A12.291,12.291,0,0,1,417.942,824.727Z" transform="translate(-357.095 -709.539)" fill="var(--gp-orange)"/>
                  <path id="Path_590" data-name="Path 590" d="M768.324,309.375s-7.777,7.622-4.511,8.555,7-7,7-7Z" transform="translate(-659.851 -268.34)" fill="#ffb9b9"/>
                  <path id="Path_591" data-name="Path 591" d="M815.85,471.359l-.933,4.355,7,.311-1.089-4.667Z" transform="translate(-699.6 -404.658)" fill="#ffb9b9"/>
                  <path id="Path_592" data-name="Path 592" d="M971.942,661.526l-.933,4.355,7,.311-1.089-4.667Z" transform="translate(-833.604 -567.915)" fill="#ffb9b9"/>
                  <path id="Path_593" data-name="Path 593" d="M829.231,285.191l.622,2.489s-17.266-3.422-16.333,5.289a60.166,60.166,0,0,0,4.978,17.11s-.311,2.8.311,3.267,0,2.022,0,2.022,5.755.778,5.911-.622a9.756,9.756,0,0,0-.156-2.8s.311,0,0-1.556-1.568-14.1-2.5-15.811c0,0,8.256,6.323,12.612,5.545a40.993,40.993,0,0,0,1.867,14.466c2.489,8.244,2.489,9.177,2.489,9.177s2.955,15.711,2.178,17.577l-.156.778h5.755s-.467-8.244,0-9.333.467-10.422-2.178-15.088c-1.873-3.3-1.524-12.886-.5-16.674a19.591,19.591,0,0,0,.573-8.884,10.407,10.407,0,0,0-4.118-6.952Z" transform="translate(-703.181 -247.578)" fill="#2f2e41"/>
                  <circle id="Ellipse_139" data-name="Ellipse 139" cx="5.6" cy="5.6" r="5.6" transform="translate(125.039 3.003)" fill="#ffb9b9"/>
                  <path id="Path_594" data-name="Path 594" d="M946.749,94.06s1.711,4.978,1.556,5.911,4.978-1.867,4.978-1.867-2.022-4.978-1.4-6.378Z" transform="translate(-817.588 -81.49)" fill="#ffb9b9"/>
                  <path id="Path_595" data-name="Path 595" d="M918.638,124.7l-5.444,2.178.311,1.867s-.467.622-.311.933-2.022,1.555-1.711,2.022-1.867,2.333-1.711,2.8-4.978,3.267-2.178,8.711a6.676,6.676,0,0,1,1.27,4.119q-.01.118-.025.237c-.311,2.333,11.822-.311,11.822-.311v-2.644s1.089-.467.933-2.489-1.089-1.089,0-2.178,1.089-.933.933-1.867c-.062-.373-.075-1.713-.067-3.188a14.154,14.154,0,0,0-2.888-8.634h0Z" transform="translate(-783.255 -109.801)" fill="#d0cde1"/>
                  <path id="Path_596" data-name="Path 596" d="M818.844,149.291l-10.111,10.577-14.777,11.666,3.267,2.644,27.221-18.2S826.777,146.024,818.844,149.291Z" transform="translate(-686.416 -130.344)" fill="#d0cde1"/>
                  <path id="Path_597" data-name="Path 597" d="M787.885,498.917s-1.089-1.867-1.867-1.244l-5.444,4.355s-9.644,2.8-.311,4.978c0,0,5.133.778,6.222,0a3.609,3.609,0,0,1,3.267-.311c.467.311,6.378-.156,6.378-1.4s-3.26-6.683-3.26-6.683S791,500.783,787.885,498.917Z" transform="translate(-671.168 -429.883)" fill="#2f2e41"/>
                  <path id="Path_598" data-name="Path 598" d="M943.977,689.084s-1.089-1.867-1.867-1.244l-5.444,4.355s-9.644,2.8-.311,4.978c0,0,5.133.778,6.222,0a3.609,3.609,0,0,1,3.267-.311c.467.311,6.378-.156,6.378-1.4s-3.26-6.683-3.26-6.683S947.088,690.951,943.977,689.084Z" transform="translate(-805.172 -593.14)" fill="#2f2e41"/>
                  <path id="Path_599" data-name="Path 599" d="M909.768,25.771s.947-8.323,9.045-5.96c0,0,5.729-1.165,7.752,5.99l2.054,7.5-.94-.489-.416.956-1.5.411-.67-1.268-.282,1.561-10.361,2.095a16.1,16.1,0,0,0,3.479-9.867L916.9,27.835Z" transform="translate(-785.84 -19.389)" fill="#2f2e41"/>
                  <path id="Path_602" data-name="Path 602" d="M631.569,401.5l-5.82-5.82a5.266,5.266,0,1,0-1.515,1.515l5.82,5.82Zm-12.874-6.058a3.748,3.748,0,1,1,5.3,0A3.749,3.749,0,0,1,618.695,395.44Z" transform="translate(-590.514 -341.233)" fill="var(--gp-orange)"/>
                </g>
              </svg>
              <p>Waiting to search!</p>
            </div>
          </div>
          <div id="search-contents" class="uk-switcher uk-tab-content">
            <div id="search-contents-stores" class="search-tab-content uk-active">
              <SearchResultsStores :results="results.stores" />
            </div>
            <div id="search-contents-coupons" class="search-tab-content">
              <SearchResultsCoupons :results="results.coupons" />
            </div>
            <div id="search-contents-loyalty" class="search-tab-content">
              <SearchResultsLoyalty :results="results.loyalty" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import UIkit from 'uikit'
import Hub from '../events/Hub'
import _ from 'lodash'

import coreMixin from '../mixins/coreMixin'
import apiMixin from '../mixins/apiMixin'

import SearchResultsCoupons from './Search/SearchResultsCoupons'
import SearchResultsLoyalty from './Search/SearchResultsLoyalty'
import SearchResultsStores from './Search/SearchResultsStores'

const searchBarDefault = false

window.UIKit = UIkit

export default {
  mixins: [apiMixin, coreMixin],
  components: {
    SearchResultsCoupons,
    SearchResultsLoyalty,
    SearchResultsStores
  },
  data () {
    return {
      'searchTerm': '',
      'results': {
        'coupons': [],
        'stores': [],
        'loyalty': []
      }
    }
  },
  computed: {
    searchBar () {
      if (this.$route.meta.searchbar !== '') {
        if (this.getConfig().showSearch === true) {
          return this.$route.meta.searchbar
        } else {
          return searchBarDefault
        }
      } else {
        return searchBarDefault
      }
    },
    searchType () {
      if (this.getConfig().searchType === 'fuzzy') {
        return 'fuzzy'
      } else {
        return 'full-text'
      }
    },
    shouldShowWaitingToSearch () {
      return this.results.coupons.length === 0 && this.results.loyalty.length === 0 && this.results.stores.length === 0
    }
  },
  methods: {
    startSearch: _.debounce(function () {
      let term = this.cleanSearchTerm(this.searchTerm)
      let coords = this.$store.getters.getCoords
      let promise = this.searchType === 'fuzzy' ? this.runFuzzySearch(term, coords) : this.runFullTextSearch(term, coords)

      promise.then(response => {
        this.results.coupons = response.data.coupons.data
        this.results.stores = response.data.stores.data
        this.results.loyalty = response.data.loyalty.data
        // this.searchTerm = ''
      }).catch(error => {
        console.log(error)
        console.log('Could not run search')
        // this.searchTerm = ''
      })
    }, 800),
    cleanSearchTerm (searchTerm) {
      return searchTerm.replace(/[\u2018\u2019\u201C\u201D]/g,
        (c) => '\'\'""'.substr('\u2018\u2019\u201C\u201D'.indexOf(c), 1))
    },
    clearSearch () {
      this.searchTerm = ''
      this.results.coupons = []
      this.results.loyalty = []
      this.results.stores = []
    }
  },
  mounted () {
    Hub.$on('click-list-item', () => {
      UIkit.modal('#modal-search').hide()
    })
  }
}
</script>

<style>
.search-results-list {
  background: #f8f8f8;
}
.search-field {
  padding-right: 40px !important;
}
.reset-search {
  border-bottom: 1px solid rgb(167, 167, 167);
  cursor: pointer;
  position: absolute;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  width: 40px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue